import { isArray, isNonNullish, isPlainObject, isString } from 'remeda';
import { jsonParseIfString, parseLayout } from './layout';
import { SidePanelPersonalizationState, SidePanelProfile } from './layout.types';

export function parseUserProfiles(raw: unknown): SidePanelProfile[] {
  const candidate = jsonParseIfString(raw);

  if (!isArray(candidate)) {
    return [];
  }

  return candidate
    .map((entry): SidePanelProfile | null => {
      if (!isPlainObject(entry) || !isString(entry.id) || entry.id === '') {
        return null;
      }

      const layout = parseLayout(entry.layout);

      return isString(entry.name) && entry.name.trim() !== '' && layout
        ? { id: entry.id, name: entry.name, source: 'user', layout }
        : null;
    })
    .filter(isNonNullish);
}

export function parsePersonalizationState(raw: unknown): SidePanelPersonalizationState | null {
  const candidate = jsonParseIfString(raw);

  if (!isPlainObject(candidate)) {
    return null;
  }

  return {
    activeProfileId: isString(candidate.activeProfileId) ? candidate.activeProfileId : null,
    draft: parseLayout(candidate.draft),
  };
}

export function parseGroupProfile(raw: unknown, groupId: string): SidePanelProfile | null {
  const candidate = jsonParseIfString(raw);

  if (!isPlainObject(candidate)) {
    return null;
  }

  const layout = parseLayout(candidate.layout);

  return isString(candidate.name) && candidate.name.trim() !== '' && layout
    ? { id: groupId, name: candidate.name, source: 'group', layout }
    : null;
}
